






























































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { UserResourceInAdminType } from '@/modules/user/models/user-resource.model'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import AdminUserTabularHeader from '@/modules/user/components/admin/AdminUserTabularHeader.vue'
import { adminUserTabularHeaderColumn } from '@/modules/user/models/columns/admin-user-tabular-header.column'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import AdminUserIdentityForm from '@/modules/user/components/admin/forms/AdminUserIdentityForm.vue'
import AdminUserChangePasswordForm from '@/modules/user/components/admin/forms/AdminUserChangePasswordForm.vue'
import AdminUserBankAccountForm from '@/modules/user/components/admin/forms/AdminUserBankAccountForm.vue'
import AdminUserBillingInfoForm from '@/modules/user/components/admin/forms/AdminUserBillingInfoForm.vue'
import AdminUserAccessibilityForm from '@/modules/role/components/admin/forms/AdminUserAccessibilityForm.vue'
import AdminUserShowSideNav from '@/modules/user/components/admin/AdminUserShowSideNav.vue'
import AdminUserUpdateSettingForm from '@/modules/user/components/admin/forms/AdminUserUpdateSettingForm.vue'
import { UserBootUseCase } from '@/modules/user/use-cases/shared/user-boot.use-case'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'کاربر'
  },
  metaInfo: {
    title: 'کاربر'
  },
  components: {
    AdminUserUpdateSettingForm,
    AdminUserShowSideNav,
    AdminUserAccessibilityForm,
    AdminUserBillingInfoForm,
    AdminUserBankAccountForm,
    AdminUserChangePasswordForm,
    AdminUserIdentityForm,
    BaseCard,

    AdminUserTabularHeader
  }
})
export default class AdminUsersShowPage extends Vue {
  constructor(
    private readonly userBootUseCase: UserBootUseCase
  ) {
    super()
  }

  @Prop() user: UserResourceInAdminType
  tabularColumns = adminUserTabularHeaderColumn(this.user.data)
}
